import { render, staticRenderFns } from "./Vault.vue?vue&type=template&id=9350ba82"
import script from "./Vault.vue?vue&type=script&lang=js"
export * from "./Vault.vue?vue&type=script&lang=js"
import style0 from "./Vault.vue?vue&type=style&index=0&id=9350ba82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports